

































































































import {
    Vue, Component, Prop, Mixins, Watch,
} from 'vue-property-decorator'
import i18n from '@/lang'

@Component
export default class OtherSelect extends Vue {
    $refs!: {
        select: any
    }

    @Prop({default: ''}) value!: any

    @Prop({default: []}) list!: any[]

    @Prop({default: false}) disabled!: any

    @Prop({default: ''}) nameLabel!: any        // name的键名

    @Prop({default: ''}) valueLabel!: any       // value的键名

    @Prop({default: false}) number!: boolean        // other输入框是否只支持数字, 这里指定number的类型

    @Prop({default: ''}) maxlength!: number     // 输入长度限制

    @Prop({default() {
        return i18n.t('please_specify')}
    }) placeholder!: any  // 输入框placeholder

    @Prop({default: false}) showText!: any // 自定义placeholder 位置

    @Prop({default: false}) multiple!: boolean

    @Prop({default: ''}) size!: string

    @Prop({default: false}) useDlg!: boolean // 交互是否使用弹窗

    specifyDlgVisible: boolean = false

    specifyModel: any = {
        otherValue: ''
    }

    get rules() {
        return {
            otherValue: {
                required: true, message: this.$t1('this_field_is_required'), trigger: 'blur'
            }
        }
    }

    get model() {
        return this.value
    }

    set model(val) {
        this.$emit('input', val)
    }

    @Watch('value', {immediate: true})
    onValueChange() {
        if (this.multiple) return;
        if (this.valueLabel) {
            if (!this.list.some(v => v[this.valueLabel] === this.value)) {
                this.specifyModel.otherValue = this.value
            }
        } else if (this.list.indexOf(this.value) === -1) {
            this.specifyModel.otherValue = this.value
        }
    }

    changeValue() {
        if (this.multiple) {
            this.model.push(this.specifyModel.otherValue);
            this.specifyModel.otherValue = '';
        } else this.model = this.specifyModel.otherValue
        this.$refs.select.blur()
    }

    changeSelect() {
        this.$emit('changeVal')
    }

    handleConfirm() {
        (this.$refs as any).specifyForm.validate(valid => {
            if (valid) {
                this.changeValue()
                this.specifyDlgVisible = false
            }
        })
    }
}
